import React from "react";
import { VisuallyHidden } from "react-aria-components";
import { t } from "ttag";

import type { Context } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";
import { slugify } from "@thelabnyc/thelabui/src/utils/text";

import { Clickable } from "../Clickables";

import styles from "./SocialIcons.module.scss";

export type Socials = React.ComponentProps<typeof Context>["value"]["socials"];

export const SocialIcons = ({
    socials,
    className,
}: {
    socials: Socials;
    className?: string;
}) => {
    if (socials.profiles.length === 0) return null;

    return (
        <ul className={concatClassNames([className, styles.root])}>
            {socials.profiles.map((profile) => (
                <li key={profile.name}>
                    <Clickable
                        className={styles.link}
                        href={profile.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-track-label={`${slugify(profile.name)}_icon`}
                    >
                        <VisuallyHidden>
                            {profile.name} {t`(opens in a new tab)`}
                        </VisuallyHidden>
                        <ImageChooserBlock
                            value={profile.icon.block}
                            attrs={{
                                "aria-hidden": true,
                                "className": styles.icon,
                            }}
                        />
                    </Clickable>
                </li>
            ))}
        </ul>
    );
};
